import { useAuth } from "@/context/AuthContext";
import { ProfileForm } from "@/components/ProfileForm";

export default function Profile() {
  const { user, setUser, settings } = useAuth();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 fade-up" data-testid="profile-page">
      <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-semibold mb-2">My profile</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-2">Analyst signature</h1>
      <p className="text-slate-400 mb-8 max-w-2xl">Your name, title and photo sign the studies and emails you send, so clients and lenders know who prepared their work.</p>
      <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-6">
        <ProfileForm user={user} company={settings?.company_name || ""} onSaved={(u) => setUser((cur) => ({ ...cur, ...u }))} />
      </div>
    </div>
  );
}
